import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-129a15cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "big my-1" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = { class: "small my-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputPracticeType = _resolveComponent("InputPracticeType")!
  const _component_Tile = _resolveComponent("Tile")!
  const _component_Practice = _resolveComponent("Practice")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Tile, {
      title: _ctx.$t('practice.practice')
    }, {
      default: _withCtx(() => [
        (_ctx.getLoading)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: require('@/assets/loader.gif'),
              width: "50",
              height: "50"
            }, null, 8, _hoisted_2))
          : _createCommentVNode("", true),
        (_ctx.word)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.word.word), 1),
              _hoisted_5,
              _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.word.meaning), 1),
              _createVNode(_component_InputPracticeType, {
                type: _ctx.type,
                onUpdateType: _cache[0] || (_cache[0] = ($event: any) => (_ctx.type = $event))
              }, null, 8, ["type"]),
              _createElementVNode("button", {
                class: "btn btn-secondary my-2",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.startPractice && _ctx.startPractice(...args)))
              }, _toDisplayString(_ctx.$t('practice.practice')), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["title"]),
    (_ctx.practiceStarted)
      ? (_openBlock(), _createBlock(_component_Tile, { key: 0 }, {
          default: _withCtx(() => [
            (_openBlock(), _createBlock(_component_Practice, {
              key: _ctx.practiceKey,
              words: _ctx.words,
              type: _ctx.type
            }, null, 8, ["words", "type"]))
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}